import React from "react";
import moment from "moment";
import themePropTypes from "../theme-prop-types";
import Text from "./text";

const Invoice = ({ name, createdAt }) => (
  <div className='invoice-item-web-sdk'>
    <strong>
      <Text label={name} />
    </strong>
    <Text
      label={
        createdAt
          ? moment(createdAt).format("dddd, MMMM D, YYYY [at] h:mm A")
          : ""
      }
    />
  </div>
);

Invoice.propTypes = themePropTypes.invoice;

export default Invoice;
